// extracted by mini-css-extract-plugin
module.exports = {"camerasListLayout":"CamerasListLayout_camerasListLayout__UtWtZ"};